import { lazy } from 'react';

import lazyRoute from '../tools/lazyRoute';

export default lazyRoute(lazy(() => import('../components/Organization/ClustersV2/TeamsConfigCluster')), { isTeamsConfigPage: true });
